import type { StaticLayerPayload } from "@config";
import { ElementLibrary } from "@library-layers/element";
import { Container } from "../Container";

export const Element = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: ElementLibrary }} />
);
